import React, { Component } from "react"
import PropTypes from "prop-types"
import { SelectBase } from "components"

class SortMapping extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selection: this.props.sortOptions[0]
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(option) {
    this.props.handleSortChange(option)
    this.setState({ selection: option })
  }

  render() {
    return (
      <SelectBase
        simpleValue
        clearable={false}
        searchable={false}
        value={this.state.selection}
        data-test="sort-filter"
        onChange={option => this.handleChange(option)}
        options={this.props.sortOptions.map((option, index) => ({
          value: option,
          label: option.label
        }))}
        style={{ width: "200px", display: "inline" }} />
    )
  }
}

export default SortMapping

SortMapping.propTypes = {
  sortOptions: PropTypes.array.isRequired,
  handleSortChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/containers/outlet-store/sort-mapping.jsx